import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogContent } from '@material-ui/core';
import {
  useHistory,
} from 'react-router-dom';
import SeedRegisterContent from './SeedRegisterContent';
import { seedAppIcons } from '../../icon/seed-icons';
import { seedRegisterFields, seedRegisterValidationSchema } from './seed-register-form';
import SeedAuthenticationRepository from '../../repository/SeedAuthenticationRepository';
import seedLogo from '../../images/logo.svg';
import pageUtilsPropTypes from '../page-prop-types';
import formFieldsPropTypes from '../../form/form-prop-types';

const SeedRegisterDialog = (props) => {
  const {
    fields,
    validationSchema,
    AuthenticationRepository,
    pageUtils,
    applicationName,
    icons,
    logo,
  } = props;
  const history = useHistory();

  const [isLoading, setIsLoading] = React.useState(false);

  const handleClose = (e) => {
    e.stopPropagation();
    history.goBack();
  };

  return (
    <Dialog
      scroll="body"
      maxWidth="sm"
      fullWidth
      open
      disableBackdropClick={isLoading}
      onClose={handleClose}
    >
      <DialogContent>
        <SeedRegisterContent
          fields={fields}
          validationSchema={validationSchema}
          AuthenticationRepository={AuthenticationRepository}
          pageUtils={pageUtils}
          applicationName={applicationName}
          icons={icons}
          logo={logo}

          isLoading={isLoading}
          setIsLoading={setIsLoading}
        />
      </DialogContent>
    </Dialog>
  );
};

SeedRegisterDialog.propTypes = {
  fields: PropTypes.arrayOf(formFieldsPropTypes),
  validationSchema: PropTypes.object,
  AuthenticationRepository: PropTypes.func,
  pageUtils: pageUtilsPropTypes.isRequired,
  logo: PropTypes.string,
  applicationName: PropTypes.string,
  icons: PropTypes.objectOf(PropTypes.object),
};

SeedRegisterDialog.defaultProps = {
  fields: seedRegisterFields,
  validationSchema: seedRegisterValidationSchema,
  AuthenticationRepository: SeedAuthenticationRepository,
  logo: seedLogo,
  applicationName: 'react-seed',
  icons: seedAppIcons,
};

export default SeedRegisterDialog;
